import { useState, useCallback } from 'react';

interface ContactMessage {
  name: string;
  email: string;
  organization: string;
  message: string;
  subject: string;
}

export const useContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailSentMessage, setEmailSentMessage] = useState('');
  const [formError, setFormError] = useState<string | null>(null);

  const submitMessage = useCallback(async (messageInfo: ContactMessage) => {
    setIsSubmitting(true);
    setFormError(null);
    setEmailSentMessage('');

    try {
      const response = await fetch(process.env.REACT_APP_CONTACT_API_URL || 'https://5kdsze9xs4.execute-api.eu-central-1.amazonaws.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(messageInfo),
      });

      if (!response.ok) throw new Error('Network error');

      setEmailSentMessage('Your email was successfully sent!');
      return true;
    } catch (error) {
      console.error('Email submission error:', error);
      setEmailSentMessage(
        'There was an error with email submission. Please try again or contact us by email at info@disgenet.com'
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  const resetForm = useCallback(() => {
    setEmailSentMessage('');
    setFormError(null);
  }, []);

  return {
    isSubmitting,
    emailSentMessage,
    formError,
    setFormError,
    submitMessage,
    resetForm,
  };
};
